<template>
  <template v-for="group in dateGroups" :key="group.completedAt ?? 'no-date'">
    <h3
      v-if="group.completedAt"
      class="tw-text-xs tw-font-medium tw-text-sf-gray-light tw-m-0"
      :data-testid="`talking-points-date-group-${group.completedAt}`"
    >
      {{ formatMeetingDate(group.completedAt) }}
    </h3>
    <TalkingPointItem
      v-for="comm in group.items"
      :key="`${comm.kind}-${comm.id}`"
      :item="comm"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { SfTime } from '@app/adapters/time'
import TalkingPointItem from '@app/application/communication/screens/inbox/components/talking-point-item.vue'
import { groupByMeetingDate } from '@app/application/communication/screens/inbox/store/utils'
import type { CheckLink, Remark } from '@app/application/communication/types'

interface Props {
  items: (Remark | CheckLink)[]
}
const props = defineProps<Props>()

const dateGroups = computed(() => groupByMeetingDate(props.items))

function formatMeetingDate(completedAt: string): string {
  return SfTime(completedAt).format('D MMM YYYY')
}
</script>
